import styled, { css } from "styled-components"
import Link from "../smart-link.js"
import { T } from "../typography.styles"

export const DropdownContainerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & > p {
    cursor: pointer;
    color: var(--white);
  }
`

export const DropdownElement = styled.div<{ visible: boolean; offset: number }>`
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  position: absolute;
  top: 64px;
  background-color: var(--white);

  transform: translateX(${(props) => props.offset + "px"});
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.14);
  border-radius: 2px;

  ::before {
    position: absolute;
    content: "";
    top: -48px;
    left: calc(25%);
    height: 48px;
    width: 50%;
    transform: translateX(${(props) => -props.offset + "px"});
  }

  ::after {
    position: absolute;
    top: -12px;
    left: calc(50% - 16px);
    content: "";
    width: 0;
    height: 0;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 12px solid var(--white);
    transform: translateX(${(props) => -props.offset + "px"});
  }
`

export const FlexRow = styled.div`
  display: flex;

  & > *:not(:last-child) {
    margin-right: 64px;
  }
`

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--azure-grey);
  opacity: 0.2;
`

export const DropdownColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`

export const FullWidthSection = styled.div`
  display: flex;
  gap: 32px;
  width: 100%;
  background-color: #f8fafb;
  padding: 20px;
  box-sizing: border-box;
  border-top: 1px solid rgba(74, 78, 87, 0.2);
  border-radius: 0 0 2px 2px;
`

const SubcategoryHeadingStyle = css`
  ${T.lg.h5.regular}
  font-weight: 500;

  margin-bottom: 16px;
  text-decoration: none;
  text-transform: none;

  :not(:first-child) {
    margin-top: 32px;
  }

  &,
  :link,
  :visited,
  :active {
    color: var(--deep-cyan);
  }
`

export const HeadingTitle = styled.p`
  ${SubcategoryHeadingStyle}
  margin-bottom: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0;
  :not(:first-child) {
    margin-top: 20px;
  }
`

export const HeadingLink = styled(Link)`
  ${SubcategoryHeadingStyle}
  margin-bottom: 12px;
  font-size: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0;

  & img {
    margin-right: 12px;
    height: 15px;
    width: 15px;
    object-fit: contain;
  }

  :not(:first-child) {
    margin-top: 24px;
  }
`

export const PanelLink = styled(Link)`
  ${T.lg.body.regular}
  font-size:16px;

  letter-spacing: 0;
  line-height: 150%;
  text-decoration: none;
  text-transform: none;

  &,
  :link,
  :visited,
  :active {
    color: var(--body-text-grey);
  }

  display: inline-grid;
  grid-template-columns: max-content max-content;
  align-items: center;

  & img {
    width: 15px;
    height: 15px;
    margin-right: 12px;
    transform: translateY(-2px); /* align nicer to text */
  }
`

export const NavLinkGroupWrapper = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  gap: 16px 32px;
`

export const NavLinkGroupRowWrapper = styled.div`
  display: flex;
  gap: 16px;
`
